/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedChevronLeft = createReactComponent(
  "square-rounded-chevron-left",
  "IconSquareRoundedChevronLeft",
  [
    ["path", { d: "M13 15l-3 -3l3 -3", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedChevronLeft as default };
//# sourceMappingURL=IconSquareRoundedChevronLeft.js.map
